import { useState, useEffect, useRef } from "react";
import { useApp } from "./context";

export function Login() {
  const { t, setShowLogin, login } = useApp();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const onKey = e => { if (e.key === "Escape") setShowLogin(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setShowLogin]);

  const submit = async e => {
    e.preventDefault();
    if (!u.trim() || !p) { setErr(true); return; }
    setLoading(true); setErr(false);
    const ok = await login(u, p);
    setLoading(false);
    if (!ok) {
      setErr(true);
      setP("");
      boxRef.current?.animate?.(
        [{ transform: "translateX(0)" }, { transform: "translateX(-7px)" },
         { transform: "translateX(7px)" }, { transform: "translateX(0)" }],
        { duration: 220 }
      );
    }
  };

  return (
    <div className="login-overlay" onMouseDown={e => e.target === e.currentTarget && setShowLogin(false)}>
      <div className="login-box" ref={boxRef} role="dialog" aria-modal="true" aria-label={t("login.title")}>
        <h2>{t("login.title")}</h2>
        <div className="l-div" />
        <div className="login-hint">{t("login.hint")}</div>
        <form className="login-form" onSubmit={submit}>
          <div>
            <label htmlFor="ba-user">{t("login.user")}</label>
            <input
              id="ba-user" value={u} autoFocus autoComplete="username"
              onChange={e => { setU(e.target.value); setErr(false); }}
            />
          </div>
          <div>
            <label htmlFor="ba-pass">{t("login.pass")}</label>
            <div style={{ position: "relative" }}>
              <input
                id="ba-pass" type={showPw ? "text" : "password"} value={p} autoComplete="current-password"
                onChange={e => { setP(e.target.value); setErr(false); }}
                style={{ paddingRight: "2.4rem" }}
              />
              <button
                type="button" onClick={() => setShowPw(s => !s)}
                aria-label={showPw ? "Sakrij lozinku" : "Prikaži lozinku"}
                style={{
                  position: "absolute", right: ".55rem", top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer",
                  color: "var(--ba-faint)", fontSize: ".9rem", lineHeight: 1, padding: ".2rem",
                }}
              >
                <i className={`bi ${showPw ? "bi-eye-slash" : "bi-eye"}`} />
              </button>
            </div>
          </div>
          {err && <div className="l-err">⚠ {t("login.error")}</div>}
          <div className="l-row">
            <button type="submit" className="btn-gold" disabled={loading}>
              {loading ? "…" : t("login.btn")}
            </button>
            <button type="button" className="l-close" onClick={() => setShowLogin(false)} aria-label="Zatvori">✕</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
